import { createFileRoute } from '@tanstack/react-router';
import { OperationsInbox } from '../../features/operations/components/OperationsInbox.js';

export const Route = createFileRoute('/_auth/operations')({
  component: OperationsInbox,
});
